import UiBtn from '../components/ui/UiBtn.vue'
import UiInput from '../components/ui/UiInput.vue'
import UIText from '../components/ui/text/UIText.vue'
import UITitleLine from '../components/ui/text/UITitleLine.vue'
import UISubText from '../components/ui/text/UISubText.vue'
import UiAuto from '../components/ui/UiAuto.vue'
import UITextHref from '../components/ui/UITextHref.vue'
import UiCheckbox from '../components/ui/UiCheckbox.vue'
import UITitle from '../components/ui/text/UITitle.vue'
import UISubTitle from '../components/ui/text/UISubTitle.vue'
import Vue from 'vue'

Vue.component('ui_sub_title_text', UISubTitle);
Vue.component('ui_text_href', UITextHref);
Vue.component('ui_btn', UiBtn);
Vue.component('ui_auto', UiAuto);
Vue.component('ui_input', UiInput);
Vue.component('ui_check', UiCheckbox);
Vue.component('ui_text', UIText);
Vue.component('ui_title', UITitle);
Vue.component('ui_title_line', UITitleLine);
Vue.component('ui_sub_text', UISubText);




// WEBPACK FOOTER //
// ./src/plugins/components.js